import React from "react";
import { useParams } from "react-router-dom";
import styles from "./Categories.module.scss";

const Categories = () => {
  const { id } = useParams();

  return (
    <div className={styles.categoriesContainer}>
      <h2>Category: {id}</h2>
    </div>
  );
};

export default Categories;
